<template>
		<VocabCardQuestion v-if="vocabCurrent" :key="vocabCurrent.id" :vocab="vocabCurrent"></VocabCardQuestion>

		<div v-else-if="loading" class="loading">
			LOADING...
		</div>

		<div v-else-if="error" class="error">
			<h1>{{error}}</h1>
		</div>
</template>

<script>
import VocabCardQuestion from './VocabCardQuestion';

export default {
	name: 'questionVocab',
	created() {
		this.fetchData();
	},
	components: {VocabCardQuestion},
	data() {
		return {
			error: null,
			loading: false,
			vocabCurrent: {},
			vocabs: []
		};
	},
	methods: {
		validateStatus(response) {
			this.loading = false;
			if (response.status >= 200 && response.status < 300) {
				return Promise.resolve(response);
			}
			else if (response.status === 404) {
				this.$router.push('/notfound');
				return Promise.reject();
			}
			else {
				console.log(response);
				return Promise.reject(new Error(response.statusText));
			}
		},
		jsonify(response) {
			return response.json();
		},
		fetchData() {
			this.error = this.post = null;
			this.loading = true;
			const vocabs = [];
			// TODO: OR USE CACHE
			fetch('https://vocabtrainer-4ddc9.firebaseio.com/vocabs.json')
			.then(this.validateStatus)
			.then(this.jsonify)
			.then((data) => {
				Object.keys(data)
				.forEach(key => {
					const vocab = data[key];
					vocab.id = key;
					vocabs.push(vocab);
				});
				this.vocabs = vocabs;
				this.vocabCurrent = this.getVocabCurrent();
			})
			.catch((error) => {
				this.error = error.toString();
			});
		},
		getVocabCurrent(prev) {
			const selector = this.$route.params.word || '';
			const antiSelector = prev || '';
			const filtered = this.vocabs.filter((vocab) => {
				if (selector.length > 0) {
					return selector.split(' ').filter((filterterm) =>
						// search in lowercased title and content; the plus paramter is used to require following words
						vocab.lang1.toLowerCase()
						.includes(filterterm.replace(/\+/ig, ' ').toLowerCase())
					).length === selector.split(' ').length;
				}
				else {
					// every vocab is good, as long as it isn't the same one as the one before
					return vocab.lang1 !== antiSelector;
				}
			})
			.map(vocab => {
				const historicData = localStorage.getItem(vocab.id) ? JSON.parse(localStorage.getItem(vocab.id)) : false;
				vocab = Object.assign(vocab, historicData || {noTotal: 0, noWrong: 0});
				// console.log(vocab);
				return vocab;
			})
			.sort((v1, v2) => {
				const v1ErrorRate = v1.noTotal === 0 ? v1.noWrong / v1.noTotal : 0;
				const v2ErrorRate = v2.noTotal === 0 ? v2.noWrong / v2.noTotal : 0;
				const v1v2NoQuestioned = v1.noTotal && v2.noTotal ? v1.noTotal / v2.noTotal : 0;

				// vocab 1 was questioned at least 3 times more often than 2 --> push vocab 2
				// vocab 2 was questioned at least 3 times more often than 1 --> push vocab 1
				if (v1v2NoQuestioned <= 1 / 3 || v1v2NoQuestioned >= 3) {
					return v1.noTotal - v2.noTotal;
				}
				// when the distribution is similar: push the one with the lower error-rate
				else {
					return v2ErrorRate - v1ErrorRate;
				}
			});

			// filtered.forEach(fi => console.log(`"${fi.lang1}": ${fi.noWrong} wrong of ${fi.noTotal}`));

			const current = filtered[0];

			if (current && current.lang1.replace('/', '') !== selector) {
				this.$router.replace({path: `/question/${encodeURI(current.lang1.replace('/', ''))}`});
			}
			return current;
		}
	},
	watch: {
		// when the route changes within the component, reevaluate which vocab to show
		'$route'(to, from) {
			this.vocabCurrent = this.getVocabCurrent(from.params.word);
		}
	}
};
</script>


// WEBPACK FOOTER //
// QuestionVocab.vue?36e99a53